import { render, staticRenderFns } from "./SearchChildTags.vue?vue&type=template&id=4169fb5e"
import script from "./SearchChildTags.vue?vue&type=script&lang=js"
export * from "./SearchChildTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports